import {
  Box,
  Container,
  Center,
  Heading,
  Stack,
  Button,
  Image,
  Text,
  Link,
  AspectRatio,
} from '@chakra-ui/react';
import React from 'react';
import { TFunction } from 'i18next';
import step1 from '@/assets/images/webp/step-1.webp';
import step2 from '@/assets/images/webp/step-2.webp';
import step3 from '@/assets/images/webp/step-3.webp';

interface SimpleStepsProps {
  t: TFunction;
}

const SimpleSteps: React.VFC<SimpleStepsProps> = ({ t }) => {
  return (
    <Box as="section" bg="white" pb="8">
      <Box
        bg="blue.500"
        h="70px"
        mt="-35px"
        sx={{ transformOrigin: '100% 0', transform: 'skewY(-1deg)' }}
      />
      <Box as="section" bg="blue.500" py="50px" scrollSnapAlign="start">
        <Container h="100%" maxW="container.xl">
          <Center mb="12">
            <Heading as="h3" color="white" size="2xl">
              {t('ar_content_in_simple_steps')}
            </Heading>
          </Center>
          <Stack align="center" h="100%" justify="center" spacing="4">
            <Stack direction={['column', 'column', 'row']} spacing="16">
              <Stack align="center" spacing="8">
                <Box w="300px">
                  <AspectRatio maxW="300px" ratio={16 / 9}>
                    <Image
                      alt={t('scan_an_area_with_scanner_app')}
                      fit="scale-down"
                      src={step1}
                      width="300px"
                    />
                  </AspectRatio>
                </Box>
                <Text color="white" fontSize="lg" fontWeight="semibold">
                  1. {t('scan_an_area_with_scanner_app')}
                </Text>
              </Stack>
              <Stack align="center" spacing="8">
                <Box w="300px">
                  <AspectRatio maxW="300px" ratio={16 / 9}>
                    <Image
                      alt={t('connect_unity_and_pretia_by_sdk')}
                      fit="scale-down"
                      src={step2}
                      width="300px"
                    />
                  </AspectRatio>
                </Box>
                <Text color="white" fontSize="lg" fontWeight="semibold">
                  2. {t('connect_unity_and_pretia_by_sdk')}
                </Text>
              </Stack>
              <Stack align="center" spacing="8">
                <Box w="300px">
                  <AspectRatio maxW="300px" ratio={16 / 9}>
                    <Image
                      alt={t('build_your_app_and_experience')}
                      fit="scale-down"
                      src={step3}
                      width="300px"
                    />
                  </AspectRatio>
                </Box>
                <Text color="white" fontSize="lg" fontWeight="semibold">
                  3. {t('build_your_app_and_experience')}
                </Text>
              </Stack>
            </Stack>
            <Link
              href={import.meta.env.VITE_DOCUMENTATION_LINK}
              target="_blank"
              variant="no-decoration">
              <Button
                colorScheme="teal"
                mt="8"
                rounded="full"
                variant="invert-solid"
                size="lg"
                w="400px">
                {t('documentation')}
              </Button>
            </Link>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default SimpleSteps;
